import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/login';
import registration from '@/components/registration';
import dashboard from '@/components/dashboard';
import profile from '@/components/updateProfile';
import management from '@/components/deviceManagement';
import download from '@/components/downloads';
import verification from '@/components/verification';
import invoice from '@/components/invoice';
import forgetpassword from '@/components/forgetpassword';
import changepassword from '@/components/changepassword';
import confirmation from '@/components/confirmation';
import notification from '@/components/notification';
import support from '@/components/support';
import Session from '@/Session';
import legal from '@/components/legal';
import privacy from '@/components/privacy';
import termsConditions from '@/components/termsConditions';
import users from '@/components/admin/users';
import userHistory from '@/components/admin/userHistory';
import productKey from '@/components/admin/productKey';
import loginHistory from '@/components/admin/loginHistory';
import usageHistory from '@/components/admin/usageHistory';
import license from '@/components/licence';
import idCloakDownload from '@/components/idCloakDownload';
import userDashboard from '@/components/userDashboard';
import registerUser from '@/components/registerUser';
import userList from '@/components/usersList';
import demoLicense from '@/components/demoLicense';
import licenseConfirmation from '@/components/licenseConfirmation'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/forgetpassword',
      name: 'forgetpassword',
      component: forgetpassword,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      component: changepassword,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/termsConditions',
      name: 'termsConditions',
      component: termsConditions,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/demoLicense',
      name: 'demoLicense',
      component: demoLicense,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/licenseConfirmation',
      name: 'licenseConfirmation',
      component: licenseConfirmation,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/idCloakDownload',
      name: 'idCloakDownload',
      component: idCloakDownload,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/registration',
      name: 'registration',
      component: registration,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: confirmation,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/legal',
      name: 'legal',
      component: legal,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/license',
      name: 'license',
      component: license,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/notification',
      name: 'notification',
      component: notification,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/',
      name: 'dashboard',
      component: dashboard,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/userDashboard',
      name: 'userDashboard',
      component: userDashboard,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/registerUser',
      name: 'registerUser',
      component: registerUser,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/userList',
      name: 'userList',
      component: userList,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: profile,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/management',
      name: 'management',
      component: management,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/downloads',
      name: 'download',
      component: download,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/verification',
      name: 'verification',
      component: verification,
      meta: {
        accessType: 'public',
      },
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: invoice,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/support',
      name: 'support',
      component: support,
      meta: {
        accessType: 'private',
      },
    },
    {
      path: '/admin/users',
      name: 'users',
      component: users,
      meta: {
        accessType: 'admin',
      },
    },
    {
      path: '/admin/userHistory',
      name: 'userHistory',
      component: userHistory,
      meta: {
        accessType: 'admin',
      },
    },
    {
      path: '/admin/productKey',
      name: 'productKey',
      component: productKey,
      meta: {
        accessType: 'admin',
      },
    },
    {
      path: '/admin/loginHistory',
      name: 'loginHistory',
      component: loginHistory,
      meta: {
        accessType: 'admin',
      },
    },
    {
      path: '/admin/usageHistory',
      name: 'usageHistory',
      component: usageHistory,
      meta: {
        accessType: 'admin',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!to.matched.length) return next('/notfound');
  const accessType = to.meta.accessType;

  if (accessType === 'admin') {
    if (Session.getAccessToken() && Session.getAccessToken().user.role === 'admin') {
      return next();
    }
    return next({
      name: 'login',
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  if (accessType === 'private') {
    if (Session.getAccessToken()) {
      return next();
    }
    return next({
      name: 'login',
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    });
  }
  if (accessType === 'public') {
    if (!Session.getAccessToken()) {
      return next();
    }
    return next({
      name: 'dashboard',
      path: '/',
    });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js